import DriveEtaIcon from "@mui/icons-material/DriveEta";
import { EmployeeServicePath, BUSINESS_TRIPS_LIST } from "utils/constants";
import ListBusinessTrips from "./List";

export const resources = {
  isMenu: true,
  icon: <DriveEtaIcon />,
  name: EmployeeServicePath + BUSINESS_TRIPS_LIST,
  title: "Командировки",
  list: <ListBusinessTrips />,
};
